/**
 * JWT template name configured in Clerk Dashboard → JWT Templates.
 * Add `companyId` (or `org_id`) to the template claims so the backend can validate tenant context.
 * @see https://clerk.com/docs/backend-requests/making/jwt-templates
 */
export const CLERK_JWT_TEMPLATE_NAME =
  import.meta.env.VITE_CLERK_TEMPLATE_NAME || 'funner-clerk-supporter';
